/*
 上传图片的通用组件,如果要上传多张图片，并使图片排列起来，可预览，可移除，请使用/common/ImgGallery组件
 提供的属性有
 width:宽度，默认320，
 height:高度，默认180，
 style:外层容器样式
 multiple:多选,
 link：显示的图片链接，可以是数组(仅当type=list的时候有效)
 onOk：上传完成之后的回调，参数依次是file(上传的文件信息),link(链接),
 onDelete:点击删除图标时的回调
 showDelete:是否显示删除图标
 */
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'
// import ClipModal from '@hlj/hlj-components/esm/ClipModal'
import { getCropData } from '@util'
import cls from 'classnames'
import { message, Progress } from 'hljd'
import React, { PureComponent } from 'react'
// import ClipModal from '../ClipModal'
import { ClipModal } from '@hlj/hlj-components'
import SlideModal from '../SlideModal'
import upload from './config'
import styles from './style.module.less'

export default class extends PureComponent {
  uploader
  fileId
  file
  upbut = 'upbut_' + Math.random().toFixed(8)
  upbox = 'upbox_' + Math.random().toFixed(8)
  static defaultProps = {
    multiple: false,
    width: 320,
    height: 180,
    link: '',
    showDelete: true,
    showEye: true,
    disabled: false,
    autoSizeError: false,
    //设置target='_blank'时点击预览会跳转到新页面显示点击的图片且onPreview失效
    target: '_self',
    autoSuffix: true,
    uptoken_url: 'image_upload_token',
    autoCut: false
  }
  state = {
    //上传进度是否显示
    progress: 'none',
    //上传进度
    percent: 0,
    isActive: false,
    previewModal: false,
    clipLink: this.props.link // 用于裁剪显示
  }

  componentDidUpdate(prevProps) {
    if (this.props.link !== prevProps.link) {
      this.setState({ clipLink: this.props.link })
    }
  }

  //上传进度条的显示和隐藏
  progressHandler = (isShow = false) => {
    this.setState({
      percent: 0,
      progress: isShow ? 'block' : 'none'
    })
  }
  /**
   * 取消上传
   */
  cancelUpload = up => {
    if (this.fileId) {
      const uploader = up || this.uploader
      uploader.removeFile(this.fileId)
    }
    this.progressHandler(false)
  }
  //移除文件
  deleteFile = () => {
    const { onDelete, link } = this.props
    if (link) {
      onDelete && onDelete(this.file, link)
    }
  }
  preview = type => {
    /**
     * 如是裁剪取消触发，且重新上传过文件
     * 则将裁剪 url 重置回之前的 link
     */
    if (type === 'cancel' && this.props.link !== this.state.clipLink) {
      this.setState({ clipLink: this.props.link })
    }

    if (this.props.onPreview) {
      this.props.onPreview(this.props.link)
    } else {
      this.setState({
        previewModal: !this.state.previewModal
      })
    }
  }

  hover = type => () => {
    const { children, disabled } = this.props
    if (!children && !disabled) {
      if (type === 'out' && this.state.isActive) {
        this.setState({
          isActive: false
        })
      } else if (this.props.link && !this.state.percent) {
        this.setState({
          isActive: true
        })
      }
    }
  }

  componentDidMount() {
    const {
      onOk,
      onAdded,
      multiple,
      onBeforeUp,
      onError,
      uptoken_url,
      autoSizeError,
      upBtn,
      javaUpTokenUrl,
      ...rest
    } = this.props

    const url = javaUpTokenUrl
      ? javaUpTokenUrl
      : '/p/wedding/home/APIUtils/' + uptoken_url

    this.uploader = upload({
      uptoken_url: url,
      tokenPath: javaUpTokenUrl && 'java',
      browse_button: upBtn || this.upbut,
      container: this.upbox,
      multi_selection: multiple,
      drop_element: upBtn || this.upbut,
      filesAdded: (up, files) => {
        onAdded && onAdded(files, up, this.progressHandler)
      },
      //上传前
      beforeUpload: (up, file) => {
        const setBeforeUpload = () => {
          this.file = null
          this.fileId = file.id
          this.progressHandler(true)
        }
        if (onBeforeUp) {
          onBeforeUp(file, up, this.progressHandler)
            .then(res => {
              setBeforeUpload()
            })
            .catch(err => {
              up.removeFile(file)
            })
        } else {
          setBeforeUpload()
        }
      },
      //上传中
      uploadProgress: (file, percent) => {
        this.setState({
          percent
        })
      },
      //上传后
      fileUploaded: (file, link, info, up) => {
        this.file = file
        this.progressHandler(false)

        if (this.props.validate && !this.props.validate(file, link, info)) {
          return
        }

        this.setState({
          clipLink: link
        })

        if (this.props.clipabled) {
          if (this.props.autoCut) {
            const cropData = getCropData(link, info, this.props.aspect)
            info.crop = cropData.crop
            this.props.onCliped && this.props.onCliped(cropData, info)
          } else {
            this.preview()
          }
        } else {
          onOk && onOk(file, link, info, up)
        }
        // this.cancelUpload(up)
      },
      //上传失败
      onError: (up, err, errTip) => {
        this.cancelUpload(up)
        onError && onError(up, err, errTip)

        if (autoSizeError && err.code === plupload.FILE_SIZE_ERROR) {
          const { max_file_size } =
            this.uploader.settings.filters || this.uploader.settings
          message.warn(
            `文件大小超过${max_file_size.replace('mb', 'M')}，请重新选择`
          )
        }
      },
      ...rest
    })
  }

  // 缩略图
  getSmallLink = link => {
    const fix = 'imageView2/2/w/400'
    if (link.indexOf('imageView') !== -1) {
      return link
    }
    if (link.indexOf('?imageMogr2') !== -1) {
      return `${link}|${fix}`
    }
    if (link.indexOf('?') !== -1) {
      return `${link}&${fix}`
    }
    if (link.indexOf('?') === -1) {
      return `${link}?${fix}`
    }
  }

  render() {
    let { progress, percent, isActive, previewModal } = this.state
    const {
      noUploadMark,
      width,
      height,
      style,
      link,
      showDelete,
      showEye,
      children,
      clipConfig,
      autoSuffix,
      disabled,
      target,
      description,
      onCliped,
      clipabled,
      preSuffix,
      aspect,
      type,
      limitSize,
      up_text = '',
      descriptionStyle = {},
      iconStyle = {}
    } = this.props
    let warpStyle = {
      width: children ? 'auto' : width,
      height: children ? 'auto' : height,
      display: 'inline-block',
      padding: '0 15px 0 15px'
    }

    return (
      <div
        onMouseOver={this.hover('over')}
        onMouseOut={this.hover('out')}
        id={this.upbox}
        className={styles.upbox}
        style={{ ...warpStyle, ...style }}
      >
        <div id={this.upbut} className={styles.upbut}>
          {children ? (
            <div className={styles.up_text}>{children}</div>
          ) : !link ? (
            noUploadMark ? null : (
              <div className={styles.uploadMarkWrap}>
                <div style={{ textAlign: 'center' }}>
                  <span style={iconStyle} className={styles.upload_mark}>
                    +
                  </span>
                  <p className={styles.upload_tip}>{up_text}</p>
                </div>
              </div>
            )
          ) : type === 'video' ? (
            <video
              controls
              src={link}
              style={{ maxHeight: height, maxWidth: width }}
              className={styles.upimg}
            />
          ) : (
            <img
              style={{ maxHeight: height, maxWidth: width }}
              className={styles.upimg}
              src={this.getSmallLink(link)}
            />
          )}
        </div>
        {disabled && <div className={styles.disabled} />}
        <div className={styles.progress} style={{ display: progress }}>
          <Progress showInfo={false} strokeWidth={5} percent={percent} />
        </div>
        <i
          onClick={() => this.cancelUpload()}
          style={{ display: progress }}
          className={'anticon anticon-cross ' + styles.closeBtn}
        />
        {!children && (
          <span
            className={cls({
              [styles.delete]: true,
              [styles.active]: isActive
            })}
          >
            {showEye && (
              <span onClick={target === '_blank' ? undefined : this.preview}>
                {target === '_blank' ? (
                  <a
                    style={{ color: '#fff' }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={link}
                  >
                    <EyeOutlined />
                  </a>
                ) : (
                  <EyeOutlined />
                )}
              </span>
            )}
            {showDelete && (
              <span onClick={this.deleteFile}>
                <DeleteOutlined />
              </span>
            )}
          </span>
        )}
        {!children &&
          description && (
            <div className={styles.description} style={{ ...descriptionStyle }}>
              {description}
            </div>
          )}
        {previewModal &&
          !clipabled && (
            <SlideModal
              autoSuffix={autoSuffix}
              suffix={preSuffix}
              visible={previewModal}
              imgList={[link]}
              onCancel={this.preview}
            />
          )}
        {previewModal &&
          clipabled && (
            <ClipModal
              aspect={aspect}
              clipConfig={clipConfig}
              onCliped={onCliped}
              visible={previewModal}
              limitSize={limitSize}
              img={this.state.clipLink}
              onCancel={this.preview}
            />
          )}
      </div>
    )
  }
}
